import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import { ClaimGoogleTransLang, StreamStatus } from '../../types/enum';
import type { FeatureDismantlingModel } from '../feature-dismantling-model';
import type { FeatureDismantlingState } from '../../types';
import { LangTypeMode } from '@/domains/translation/enums';

@injectable()
export class FeatureDismantlingModelImpl extends AbstractModel<FeatureDismantlingState> implements FeatureDismantlingModel {
    private initializeFeatureDismantlingState(): FeatureDismantlingState {
        return {
            patentSN: '',
            patentId: '',
            claimLang: '',
            claims: [],
            streamStatus: StreamStatus.PROGRESS_INIT,
            transLang: ClaimGoogleTransLang.DEFAULT,
            transLangType: LangTypeMode.ORIGINAL,
            transLoading: false,
        };
    }
    protected _modelData: FeatureDismantlingState = this.initializeFeatureDismantlingState();
    public defaultModelData: FeatureDismantlingState = this.initializeFeatureDismantlingState();
}